import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomModal from '@/DesignSystem/components/custom-modal/CustomModal';

const PrediccionDelTiempo = ({ prediction, open = false, onClose }) => {
    if (!prediction) return null;

    const {
        viento,
        temperatura,
        humedadRelativa,
        uvMax,
        estadoCielo,
        probPrecipitacion,
        rachaMax,
        sensTermica,
        ciudad,
        provincia,
    } = prediction;

    const vientoData = viento?.[0] || {};
    const estadoTexto = estadoCielo?.[0]?.descripcion;
    const precipitacion = probPrecipitacion?.[0]?.value;
    const rachaMaxValue = rachaMax?.[0]?.value;

    if (!open) return null;

    return (
        <CustomModal open={open} onClose={onClose} title={'Detalles del clima'} width="90%">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                {ciudad && <Typography fontSize={14}>Ciudad: {ciudad}</Typography>}
                {provincia && <Typography fontSize={14}>Provincia: {provincia}</Typography>}
                {estadoTexto && <Typography fontSize={14}>Estado del cielo: {estadoTexto}</Typography>}
                {temperatura && (
                    <Typography fontSize={14}>
                        Temperatura: Min: {temperatura?.minima}°C, Máx: {temperatura?.maxima}°C
                    </Typography>
                )}
                {sensTermica && (
                    <Typography fontSize={14}>
                        Sensación térmica: Min: {sensTermica?.minima}°C, Máx: {sensTermica?.maxima}°C
                    </Typography>
                )}
                {humedadRelativa && (
                    <Typography fontSize={14}>
                        Humedad relativa: Min: {humedadRelativa?.minima}% - Máx: {humedadRelativa?.maxima}%
                    </Typography>
                )}
                {vientoData?.direccion && (
                    <Typography fontSize={14}>
                        Viento: {vientoData?.direccion} a {vientoData?.velocidad} km/h
                    </Typography>
                )}
                {rachaMaxValue && <Typography fontSize={14}>Racha máxima: {rachaMaxValue} km/h</Typography>}
                {precipitacion && (
                    <Typography fontSize={14}>Probabilidad de precipitación: {precipitacion}%</Typography>
                )}
                {uvMax && <Typography fontSize={14}>Índice UV Máx: {uvMax}</Typography>}

                <Typography fontSize={12} fontStyle={'italic'} mt={1}>
                    *Datos obtenidos de la Agencia Estatal de Meteorología
                    <Typography component={'span'} fontSize={12} mx={0.5}>
                        &#40;AEMET&#41;
                    </Typography>
                    de España.
                </Typography>

                <Typography fontSize={12} fontStyle={'italic'} mt={0}>
                    **Los datos se mostrarán cuando falten 7 días o menos para el partido.
                </Typography>
            </Box>
        </CustomModal>
    );
};

export default PrediccionDelTiempo;
